// extracted by mini-css-extract-plugin
export default {"buttonLoginContainer":"ButtonLoginByPhone_buttonLoginContainer__5Vbjg","button":"ButtonLoginByPhone_button__J-pWa"};